import { createContext, type Dispatch, type SetStateAction } from "react";

export const KeyContext = createContext<
  [number, Dispatch<SetStateAction<number>>]
>([0, () => {}]);
